import React, { useEffect, useState } from "react";
import { Nav, Navbar } from "react-bootstrap";
import "../../styles/HeaderStyle.css";
import { Link, useNavigate } from "react-router-dom";

import Logo from "../../assets/images/header/logo.jpg";

function Header() {
  const [nav, setNav] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // window.addEventListener("scroll", changeValueOnScroll);

    // Check localStorage for organizer data
    const organizerData = localStorage.getItem("organizer");
    if (organizerData) {
      setIsLoggedIn(true);
    }

    // Cleanup scroll event on unmount
    // return () => window.removeEventListener("scroll", changeValueOnScroll);
    // return;
  }, []);

  const changeValueOnScroll = () => {
    const scrollValue = document?.documentElement?.scrollTop;
    scrollValue > 100 ? setNav(true) : setNav(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("organizer");
    localStorage.removeItem("tokenJwt");
    setIsLoggedIn(false);
    navigate("/login");
  };

  return (
    <header>
      <Navbar
        collapseOnSelect
        expand="lg"
        className={`${nav === true ? "sticky" : ""} `}
      >
        <div className="container_row">
          <Navbar.Brand as={Link} to="/">
            <Link to="/" className="logo">
              <img src={Logo} alt="Logo" />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link as={Link} to="/">
                Home
              </Nav.Link>
              <Nav.Link as={Link} to="/about-us">
                About
              </Nav.Link>
              <Nav.Link as={Link} to="/events">
                Events
              </Nav.Link>
              <Nav.Link as={Link} to="/resources">
                Resources
              </Nav.Link>
              <Nav.Link as={Link} to="/contact">
                Contact Us
              </Nav.Link>
              {!isLoggedIn ? (
                <>
                  <Nav.Link as={Link} className="head-host" to="/login">
                    Host A Seminar
                  </Nav.Link>
                  <Nav.Link as={Link} to="/login">
                    Organiser Login
                  </Nav.Link>
                </>
              ) : (
                <>
                  <Nav.Link as={Link} className="head-host" to="/seminar">
                    Host A Seminar
                  </Nav.Link>
                  <Nav.Link
                    as="button"
                    onClick={handleLogout}
                    className="logout-btn"
                  >
                    Logout
                  </Nav.Link>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </div>
      </Navbar>
    </header>
  );
}
export default Header;
